import { apiClient } from '@/lib/api-client'

export interface CreateRegionRequest {
  name: string
  stateId: string
}

export interface CreateCityRequest {
  name: string
  regionId: string
  stateId: string
}

export interface CreateAreaRequest {
  name: string
  cityId: string
  description?: string
  isActive?: boolean
}

export const regionService = {
  listStates: (token: string) =>
    apiClient.get('/states', token),

  createRegion: (data: CreateRegionRequest, token: string) =>
    apiClient.post('/regions', data, token),

  listRegions: (stateId: string, token: string) =>
    apiClient.get(`/regions?stateId=${stateId}`, token),

  createCity: (data: CreateCityRequest, token: string) =>
    apiClient.post('/cities', data, token),

  listCities: (params: { regionId?: string; stateId?: string }, token: string) => {
    const query = new URLSearchParams()
    if (params.regionId) query.append('regionId', params.regionId)
    if (params.stateId) query.append('stateId', params.stateId)
    return apiClient.get(`/cities?${query.toString()}`, token)
  },

  createArea: (data: CreateAreaRequest, token: string) =>
    apiClient.post('/areas', data, token),

  listAreas: (params: { cityId?: string; activeOnly?: boolean }, token: string) => {
    const query = new URLSearchParams()
    if (params.cityId) query.append('cityId', params.cityId)
    if (params.activeOnly) query.append('activeOnly', 'true')
    return apiClient.get(`/areas?${query.toString()}`, token)
  },

  deleteArea: (id: string, token: string) =>
    apiClient.delete(`/areas/${id}`, token),
}
